// @ts-nocheck
import VideoRecorder from 'react-video-recorder'

interface CustomVideoRecorderProps {
  onStartRecording: Function
  onRecordingComplete: (videoBlob: Blob) => void
}

export const CustomVideoRecorder = ({
  onStartRecording,
  onRecordingComplete,
}: CustomVideoRecorderProps) => {
  const constraints = {
    audio: true,
    video: {
      width: { ideal: 640, max: 1300 },
      height: { ideal: 480, max: 1300 },
      facingMode: 'user',
    },
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
      }}
    >
      {/* @ts-ignore */}
      <VideoRecorder
        onStartRecording={onStartRecording}
        onRecordingComplete={onRecordingComplete}
        timeLimit={30 * 1000}
        countdownTime={0}
        showReplayControls={true}
        isFlipped={false}
        constraints={constraints}
      />
      <p>Maximum length: 30 seconds</p>
    </div>
  )
}
